import AppConfig from '../../../lib/AppConfig';
import { cleanApiError, handleResponse } from '../../../utils/handleResponse';
import { getAPIHeaders } from '../../../utils/helpers';
import { Role, RolePermission, UpdateRolePermission } from '../types/response/Role';

export namespace RoleRepository {
	// List Roles
	export async function listRoles(): Promise<Role[]> {
		try {
			const endPoint = `/fineract-provider/api/v1/roles`;
			const url = `${AppConfig.api_url}${endPoint}`;
			const response = await fetch(url, {
				headers: await getAPIHeaders(),
			});
			return await handleResponse(response);
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}

	// Create Role
	export async function createRole(roleData: { name: string; description: string }): Promise<any> {
		try {
			const headers = await getAPIHeaders();
			headers.set('Content-Type', 'application/json');

			const endPoint = `/fineract-provider/api/v1/roles`;
			const url = `${AppConfig.api_url}${endPoint}`;
			const response = await fetch(url, {
				method: 'POST',
				// mode: 'no-cors',
				headers,
				body: JSON.stringify(roleData),
			});
			return await handleResponse(response);
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}

	// Get Role by ID
	export async function getRole(roleId: number): Promise<Role> {
		try {
			const endPoint = `/fineract-provider/api/v1/roles/${roleId}`;
			const url = `${AppConfig.api_url}${endPoint}`;
			const response = await fetch(url, {
				headers: await getAPIHeaders(),
			});
			return await handleResponse(response);
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}

	// Delete Role by ID
	export async function deleteRole(roleId: number): Promise<void> {
		try {
			const endPoint = `/fineract-provider/api/v1/roles/${roleId}`;
			const url = `${AppConfig.api_url}${endPoint}`;
			const response = await fetch(url, {
				method: 'DELETE',
				headers: await getAPIHeaders(),
			});
			await handleResponse(response);
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}

	// Disable Role by ID
	export async function disableRole(roleId: number): Promise<void> {
		try {
			const endPoint = `/fineract-provider/api/v1/roles/${roleId}?command=disable`;
			const url = `${AppConfig.api_url}${endPoint}`;
			const response = await fetch(url, {
				method: 'POST',
				headers: await getAPIHeaders(),
			});
			await handleResponse(response);
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}

	// Enable Role by ID
	export async function enableRole(roleId: number): Promise<void> {
		try {
			const endPoint = `/fineract-provider/api/v1/roles/${roleId}?command=enable`;
			const url = `${AppConfig.api_url}${endPoint}`;
			const response = await fetch(url, {
				method: 'POST',
				headers: await getAPIHeaders(),
			});
			await handleResponse(response);
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}

	// Update Role by ID
	export async function updateRole(
		roleId: number,
		roleData: { description: string },
	): Promise<any> {
		try {
			const endPoint = `/fineract-provider/api/v1/roles/${roleId}`;
			const url = `${AppConfig.api_url}${endPoint}`;
			const headers = await getAPIHeaders();
			headers.set('Content-Type', 'application/json');
			const response = await fetch(url, {
				method: 'PUT',
				headers,
				body: JSON.stringify(roleData),
			});
			return await handleResponse(response);
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}

	// Get Role Permissions
	export async function getRolePermissions(roleId: number): Promise<RolePermission> {
		try {
			const endPoint = `/fineract-provider/api/v1/roles/${roleId}/permissions`;
			const url = `${AppConfig.api_url}${endPoint}`;
			const response = await fetch(url, {
				headers: await getAPIHeaders(),
			});
			return await handleResponse(response);
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}

	// Update Role Permissions
	export async function updateRolePermissions(
		roleId: number,
		permissionsData: UpdateRolePermission,
	): Promise<any> {
		try {
			const endPoint = `/fineract-provider/api/v1/roles/${roleId}/permissions`;
			const url = `${AppConfig.api_url}${endPoint}`;
			const headers = await getAPIHeaders();
			headers.set('Content-Type', 'application/json');
			const response = await fetch(url, {
				method: 'PUT',
				headers,
				body: JSON.stringify(permissionsData),
			});
			return await handleResponse(response);
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}
}
